import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';


export const LayoutVerticalSliderDefinition: IdtComponentDefinition = {
  id: 'layout-vertical-slider',
  role: IdtComponentRole.Layout,
  numSlots: 2,
  defaultSlot: 1
};

export const LayoutVerticalSliderCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Carrusel Vertical',
  group: CmsComponentGroups.Basic,
  availablePlatforms: ['web'],
  initialSettings: () => {
    return {
      general: {},
      styles: {}
    };
  }
};
